import { Injectable } from '@angular/core';

@Injectable()
export class FileUploadService {
  imageData: string | ArrayBuffer;

  constructor() { }
  fileHandeleBase64(event) {
    return new Promise((resolve,reject)=>{
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // console.log(reader.result);
      resolve(reader.result)
      };
    })
    // // console.log(event)
    // console.log(this.imageData)
    // return this.imageData
  }
  urlHandleBase64(urlImg){
    
    return new Promise((resolve,reject)=>{

      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = urlImg;
      img.onload = () =>{
        
        const canvas: HTMLCanvasElement = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx: CanvasRenderingContext2D = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL: string = canvas.toDataURL("image/png");
        resolve(dataURL);
        // resolve(dataURL.replace(/^data:image\/(png|jpg);base64,/, ""))

      };
    })
   }
 
}
